// Pure conversions between a fixture's normalized geometry (persisted in
// FloorplanConfig.fixtures) and the pixel-space "frame" react-moveable drives
// on the canvas. The frame model — a top-left translate + width/height +
// rotation-around-center — is identical to the burn-in model in
// fixtureSymbolRender.ts, so persisting a frame back to normalized coords
// reproduces on-canvas exactly what gets burned into the generated image.

export interface FixtureFramePx {
  /** px offset of the UNrotated box's top-left from the container origin */
  translate: [number, number];
  /** box size in px */
  width: number;
  height: number;
  /** degrees, rotation around the box center */
  rotate: number;
}

export interface FixtureGeom {
  x: number;
  y: number;
  width: number;
  height: number;
  rotation?: number;
}

export interface ContainerSizePx {
  width: number;
  height: number;
}

export function fixtureToFramePx(f: FixtureGeom, c: ContainerSizePx): FixtureFramePx {
  return {
    translate: [f.x * c.width, f.y * c.height],
    width: f.width * c.width,
    height: f.height * c.height,
    rotate: f.rotation ?? 0,
  };
}

export function framePxToFixture(
  frame: FixtureFramePx,
  c: ContainerSizePx,
): { x: number; y: number; width: number; height: number; rotation: number } {
  return {
    x: frame.translate[0] / c.width,
    y: frame.translate[1] / c.height,
    width: frame.width / c.width,
    height: frame.height / c.height,
    rotation: frame.rotate,
  };
}
